import { EffectsCommandMap } from 'dva';
import type {
  ChangeAction,
  OnClick_Graph_FullScreenBtn_Action,
  OnCancel_Graph_FullScreenDrawer_Action,
  OnChange_Graph_Tab_Action,
} from './types';

export const graphEffects = {
  * onClick_Graph_FullScreenBtn({}: OnClick_Graph_FullScreenBtn_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {},
    });
  },
  * onCancel_Graph_FullScreenDrawer({}: OnCancel_Graph_FullScreenDrawer_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {},
    });
  },
  * onChange_Graph_Tab({ payload }: OnChange_Graph_Tab_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {},
    });
  },
};
